import React, { useEffect, useState, createElement } from 'react';
import { TopBanner } from './components/TopBanner';
import { PopNotification } from './components/PopNotification';
import { HeroSection } from './components/HeroSection';
import { PainSection } from './components/PainSection';
import { ForYourBabySection } from './components/ForYourBabySection';
import { SolutionSection } from './components/SolutionSection';
import { ProductSection } from './components/ProductSection';
import { BonusesSection } from './components/BonusesSection';
import { ValueStackSection } from './components/ValueStackSection';
import { TestimonialsSection } from './components/TestimonialsSection';
import { GuaranteeSection } from './components/GuaranteeSection';
import { FAQSection } from './components/FAQSection';
import { ShareSection } from './components/ShareSection';
import { FinalCTASection } from './components/FinalCTASection';
import { Footer } from './components/Footer';
import { Modal } from './components/Modal';
import { PrivacyPolicyContent, TermsOfServiceContent, DisclaimerContent } from './components/ModalContent';
type ModalType = 'privacy' | 'terms' | 'disclaimer' | null;
export function App() {
  const [openModal, setOpenModal] = useState<ModalType>(null);
  useEffect(() => {
    // Facebook Pixel - Reemplaza YOUR_PIXEL_ID con tu Pixel ID real
    const pixelId = 'YOUR_PIXEL_ID';
    const f = window as any;
    if (!f.fbq) {
      const n = (f.fbq = function (...args: any[]) {
        n.callMethod ? n.callMethod.apply(n, args) : n.queue.push(args);
      }) as any;
      if (!f._fbq) f._fbq = n;
      n.push = n;
      n.loaded = true;
      n.version = '2.0';
      n.queue = [] as any[];
      const script = document.createElement('script');
      script.async = true;
      script.src = 'https://connect.facebook.net/en_US/fbevents.js';
      document.head.appendChild(script);
    }
    f.fbq('init', pixelId);
    f.fbq('track', 'PageView');
    f.fbq('track', 'ViewContent');
  }, []);
  const handleOpenModal = (modalId: ModalType) => {
    setOpenModal(modalId);
  };
  const handleCloseModal = () => {
    setOpenModal(null);
  };
  return <div className="w-full min-h-screen" data-id="element-0">
      <TopBanner data-id="element-1" />
      <PopNotification data-id="element-2" />
      <HeroSection data-id="element-3" />
      <ForYourBabySection data-id="element-4" />
      <PainSection data-id="element-5" />
      <SolutionSection data-id="element-6" />
      <ProductSection data-id="element-7" />
      <BonusesSection data-id="element-8" />
      <ValueStackSection data-id="element-9" />
      <TestimonialsSection data-id="element-10" />
      <GuaranteeSection data-id="element-11" />
      <FAQSection data-id="element-12" />
      <ShareSection data-id="element-13" />
      <FinalCTASection data-id="element-14" />
      <Footer onOpenModal={handleOpenModal} data-id="element-15" />

      <Modal isOpen={openModal === 'privacy'} onClose={handleCloseModal} title="Política de Privacidad" data-id="element-16">
        <PrivacyPolicyContent data-id="element-17" />
      </Modal>

      <Modal isOpen={openModal === 'terms'} onClose={handleCloseModal} title="Términos de Servicio" data-id="element-18">
        <TermsOfServiceContent data-id="element-19" />
      </Modal>

      <Modal isOpen={openModal === 'disclaimer'} onClose={handleCloseModal} title="Descargo de Responsabilidad" data-id="element-20">
        <DisclaimerContent data-id="element-21" />
      </Modal>
    </div>;
}